import React from "react";
import "../styles/aratext.css";
import dovizImage from "../assets/sube/doviz.jpg";
import { Link } from "react-router-dom";
import Reveal from "./Reveal";

const Aratext: React.FC = () => {
  return (
    <section className="aratext-section">
      <div className="aratext-content">
        <Reveal variant="fade-right" duration={700} className="aratext-text">
          <h1 className="aratext-title">ATS DÖVİZ</h1>
          <h2 className="aratext-subtitle">Güvenilir Döviz İşlem Ortağınız</h2>
          <p className="aratext-description">
            10 yılı aşkın sektör tecrübemizle yalnızca döviz piyasalarına odaklanan, güveni,
            şeffaflığı ve hızı merkeze alan bir hizmet anlayışı sunuyoruz. Güncel döviz kurlarını
            anlık takip ederek bireysel ve kurumsal müşterilerimize güvenli, hızlı ve rekabetçi
            döviz alım–satım çözümleri sağlıyoruz. Amacımız, döviz işlemlerinizde her zaman
            doğru fiyatla, doğru zamanda yanınızda olmak.
          </p>
          <div className="aratext-buttons">
            <Link to="/contact" className="aratext-btn aratext-btn-primary">
              Hemen İletişime Geç
            </Link>
            <Link to="/about" className="aratext-btn aratext-btn-outline">
              Hakkımızda
            </Link>
          </div>
        </Reveal>
        <Reveal variant="fade-left" duration={700} delay={150} className="aratext-image-wrapper">
          <img src={dovizImage} alt="ATS Döviz" className="aratext-image" />
        </Reveal>
      </div>
    </section>
  );
};

export default Aratext;
